import { type ReactNode, useState } from 'react'
import type { Theme } from '@mui/material/styles'
import { Box, Collapse, type SxProps, Typography } from '@mui/material'
import { SidebarTypoButton } from 'core/app-shell/sidebar/collapsible-menu/SidebarTypoButton.tsx'
import * as lsUtils from 'common/local-storage/local-storage-utils.ts'
import { ToggleExpandButton } from 'core/app-shell/sidebar/collapsible-menu/ToggleExpandButton.tsx'
import 'core/app-shell/sidebar/collapsible-menu/SidebarCollapsableMenu.css'

export interface SidebarCollapsableMenuProps {
  isOpenLocalStorageKey: string
  title: string
  children?: ReactNode
  newButtonText?: string
  onNewButtonClicked?: (e: React.MouseEvent<HTMLElement>) => void
  slotSx?: {
    root?: SxProps<Theme>
    collapse?: SxProps<Theme>
  }
}

export function SidebarCollapsableMenu({
  title,
  newButtonText,
  onNewButtonClicked,
  children,
  isOpenLocalStorageKey,
  slotSx,
}: SidebarCollapsableMenuProps) {
  const initialIsOpen = lsUtils.readBool(isOpenLocalStorageKey)
  const [open, setOpenRaw] = useState<boolean>(initialIsOpen ?? true)
  const setOpen = (value: boolean): void => {
    setOpenRaw(value)
    lsUtils.writeBool(isOpenLocalStorageKey, value)
  }
  const itemColor = (theme: Theme) => theme.palette.grey[600]

  return (
    <Box
      className={'sidebarCollapsableMenu'}
      sx={{
        pl: 0.25,
        pr: 0.5,
        py: 0.5,
        // borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
        ...(slotSx?.root ?? {}),
      }}
    >
      <Box className="sidebarNewTypoButtonContainer">
        <Box
          sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer', color: itemColor }}
          onClick={() => setOpen(!open)}
        >
          <ToggleExpandButton sx={{ color: itemColor }} open={open} />
          <Typography variant="body1" sx={{ color: itemColor }}>
            {title}
          </Typography>
        </Box>
        {newButtonText && <SidebarTypoButton onClick={onNewButtonClicked} text={newButtonText} />}
      </Box>

      <Collapse in={open} sx={{ width: '100%', paddingLeft: '1rem', ...(slotSx?.collapse ?? {}) }}>
        {children}
      </Collapse>
    </Box>
  )
}
